
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#231F20","d":"M14.406 7.423h-3.665a.476.476 0 00.28-.432V.75a.474.474 0 00-.475-.475h-6.24a.475.475 0 00-.475.475v6.242c0 .193.116.357.282.432H.594a.475.475 0 00-.475.475v6.242c0 .261.212.475.475.475h6.242a.476.476 0 00.475-.475V7.898a.474.474 0 00-.282-.432h.942a.476.476 0 00-.282.432v6.242c0 .261.213.475.475.475h6.242a.476.476 0 00.475-.475V7.898a.475.475 0 00-.475-.475zM4.781 1.225h5.292v5.292H4.781V1.225zm1.58 12.44H1.069V8.372h5.292v5.293zm7.571 0H8.639V8.372h5.293v5.293z"}}),_c('path',{attrs:{"fill":"#231F20","d":"M8.203 4.8H6.719l-.31.893h-.693l1.448-3.832h.597l1.451 3.832h-.694L8.203 4.8zm-1.297-.537h1.11l-.555-1.589-.555 1.589zM2.294 12.909V9.077h1.313c.434 0 .763.086.99.261.226.173.339.432.339.776a.823.823 0 01-.142.473.923.923 0 01-.416.327.844.844 0 01.48.316c.113.156.17.341.17.559 0 .359-.116.637-.346.83-.231.193-.561.29-.991.29H2.294zm.666-2.22h.653c.207 0 .369-.047.486-.142a.482.482 0 00.175-.398c0-.189-.054-.324-.162-.409-.109-.084-.277-.127-.505-.127H2.96v1.076zm0 .49v1.198h.74c.208 0 .372-.052.49-.156a.546.546 0 00.176-.432c0-.396-.204-.603-.611-.61H2.96zM12.846 11.662c-.039.408-.19.727-.453.955-.264.23-.612.343-1.05.343-.306 0-.573-.071-.807-.216a1.425 1.425 0 01-.537-.618 2.179 2.179 0 01-.197-.929v-.357c0-.361.063-.681.19-.955.129-.275.313-.487.552-.638.239-.147.517-.224.83-.224.423 0 .764.115 1.021.343.258.23.408.555.45.975h-.663c-.033-.275-.113-.475-.241-.597-.129-.123-.317-.183-.567-.183-.29 0-.512.105-.667.316-.156.212-.233.522-.238.931v.342c0 .413.074.729.223.947.147.218.365.326.651.326.261 0 .458-.06.589-.177.132-.117.215-.313.251-.585h.663z"}})])
          )
        }
      }
    